import { render, staticRenderFns } from "./AdminActivate.vue?vue&type=template&id=0c6b2738&scoped=true&"
import script from "./AdminActivate.vue?vue&type=script&lang=ts&"
export * from "./AdminActivate.vue?vue&type=script&lang=ts&"
import style0 from "./AdminActivate.vue?vue&type=style&index=0&id=0c6b2738&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6b2738",
  null
  
)

export default component.exports